export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://alegriacadena-api-staging.clicktotravel.es/api',
    baseUrl: 'https://alegriacadena-api-staging.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'Te7xV3YxaIT7yKGA!pt',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: false, // General switch for booking engine
    booking_engine_top_enabled: true, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
    normalizeUrlsToLowercase: true,
    hotelRequestMotor: false, // Add request hotel motor
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    booking_engine_widget: true, // Use widget booking engine
    booking_engine_widget_dynamic: true, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://alegriacadena-dev.clicktotravel.es/',
    organizationName: 'Babylon',
    hideUserCentrics: false, //Only for dev on true
};
